export default "__VITE_ASSET__DBm7YrqK__"